import "./es.array.concat-d1c9b847.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.map-d821aaf5.js";
import "./es.array.reduce-2985ed2c.js";
import "./es.array.splice-801adf1d.js";
import "./es.object.to-string-f55666a8.js";
import { _ as K } from "./export-cdcbfb2b.js";
import { o as L } from "./object-to-array-0474b7e7.js";
import A, { useState as s } from "react";
import { jsx as M } from "react/jsx-runtime";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-is-node-a035d787.js";
import "./environment-ddee5959.js";
import "./function-uncurry-this-clause-99074d1c.js";
var Q = K, U = L.values;
Q({ target: "Object", stat: !0 }, {
  values: function(t) {
    return U(t);
  }
});
var W = {
  allCheckboxChecked: 0,
  checkboxCheckedValues: [],
  setCheckboxChecked: function(t, C) {
  },
  setAllCheckboxChecked: function(t) {
  },
  assignCheckboxesDefaultValues: function(t) {
  },
  showOptionsEnabled: !1,
  setShowOptionsEnabled: function(t) {
  },
  showCheckboxEnabled: !1,
  setShowCheckboxEnabled: function(t) {
  },
  isStickyColumnEnabled: !1,
  setIsStickyColumnEnabled: function(t) {
  },
  showAllTableDataContent: !0,
  setShowAllTableDataContent: function(t) {
  },
  sortOrder: {
    columnNumber: 0,
    value: "default"
  },
  setSortOrder: function(t) {
  }
}, X = /* @__PURE__ */ A.createContext(W), Ee = function(t) {
  var C = t.children, k = s([]), r = k[0], h = k[1], v = A.useState({
    columnNumber: 0,
    value: "default"
  }), V = v[0], _ = v[1], f = s(!1), D = f[0], T = f[1], m = s(!1), I = m[0], g = m[1], x = s(!1), y = x[0], j = x[1], p = s(0), P = p[0], S = p[1], E = s(!0), R = E[0], $ = E[1], w = s([]), N = w[0], q = w[1], z = function(e, o) {
    var n, c = r.findIndex(function(b) {
      return b.id === e;
    });
    if (!((n = r[c]) != null && n.disabled)) {
      var i = [].concat(r);
      c >= 0 ? (i.splice(c, 1, {
        id: e,
        value: o,
        disabled: !1
      }), h(i)) : (i.push({
        id: e,
        value: o
      }), h(i));
    }
  }, B = function(e) {
    e === void 0 && (e = []);
    var o = [].concat(r, e);
    h(o);
  }, O = function(e, o) {
    var n = e != null && e.disabled ? e.value : o;
    return {
      id: e.id,
      value: n,
      disabled: !!(e != null && e.disabled)
    };
  }, F = function(e, o, n) {
    o === void 0 && (o = []);
    var c = [].concat(o, r);
    if (o.length === 0 && !n) {
      var i = c.map(function(a) {
        return O(a, e);
      });
      h(i), S(e);
      return;
    }
    var b = c.filter(function(a) {
      return n && n.includes(a.id);
    }).map(function(a) {
      return O(a, e);
    }), H = [].concat(r, b), J = Object.values(H.reduce(function(a, u) {
      return a[u.id] ? a[u.id].value = u.value : a[u.id] = u, a;
    }, {}));
    h(J), S(e);
  }, G = function(e) {
    g(e);
  };
  return /* @__PURE__ */ M(X.Provider, {
    value: {
      allCheckboxChecked: P,
      checkboxCheckedValues: r,
      setCheckboxChecked: z,
      setAllCheckboxChecked: F,
      assignCheckboxesDefaultValues: B,
      showOptionsEnabled: D,
      setShowOptionsEnabled: T,
      showCheckboxEnabled: I,
      setShowCheckboxEnabled: G,
      isStickyColumnEnabled: y,
      setIsStickyColumnEnabled: j,
      showAllTableDataContent: R,
      setShowAllTableDataContent: $,
      sortOrder: V,
      setSortOrder: _,
      rowIds: N,
      setRowIds: q
    },
    children: C
  });
};
export {
  X as TableContext,
  Ee as TableProvider
};
